import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getAlertsReport } from '../../services/Reports';

function useGetAlertsReport(fleetId: string, query: string): UseQueryResult<any> {
  return useQuery(
    ['report-alerts', fleetId, query],
    async (): Promise<any> => getAlertsReport(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: false,
      refetchInterval: false,
    },
  );
}

export default useGetAlertsReport;
